import { jsx as _jsx } from "react/jsx-runtime";
import { Carousel, CarouselVariant, LightBoxThumbSlide } from '@as/cotopaxi';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { useEffect, useCallback, useState } from 'react';
export const LightBoxThumbSlider = ({ activeSlideIndex, alt, mediaCollection, onActiveSlideIndexChange, }) => {
    const [gallerySwiper, setGallerySwiper] = useState(null);
    useEffect(() => {
        if (gallerySwiper !== null && !!activeSlideIndex) {
            const activeSlide = gallerySwiper.slides[activeSlideIndex];
            if ((activeSlide === null || activeSlide === void 0 ? void 0 : activeSlide.className.indexOf('swiper-slide-visible')) < 0) {
                gallerySwiper.slideTo(activeSlideIndex);
            }
        }
    }, [activeSlideIndex]);
    useEffect(() => {
        if (gallerySwiper !== null) {
            gallerySwiper.update();
        }
    }, [mediaCollection]);
    const onThumbClick = function (index) {
        if (index !== activeSlideIndex) {
            onActiveSlideIndexChange(index);
        }
    };
    const renderSlide = useCallback((image, index) => (_jsx("div", { onClick: () => onThumbClick(index), children: _jsx(LightBoxThumbSlide, { active: activeSlideIndex === index, isVideo: image.isVideo, imagePath: image.sourceSet[ProductImageSizesPortraitEnum.thumb], alt: alt }) }, `image_${index}`)), [activeSlideIndex]);
    const lightBoxThumbSliderCarouselConfig = {
        variant: CarouselVariant.LIGHT_BOX_THUMB,
        configurationOverrides: {
            initialSlide: activeSlideIndex,
            getSwiper: setGallerySwiper,
            autoHeight: true,
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 24,
        },
    };
    return (_jsx(Carousel, Object.assign({}, lightBoxThumbSliderCarouselConfig, { dataQA: "light_box_thumb_slider", children: mediaCollection.map((image, index) => renderSlide(image, index)) })));
};
